// Hard-coded for now. Replace with an API call when categories are managed in the backend.
export const KB_CATEGORIES = [
  "Getting Started",
  "Buying",
  "Selling",
  "Payments & Payouts",
  "Shipping & Returns",
  "Account & Security",
  "Policies",
];

export const KB_STATUS = { DRAFT: "DRAFT", PUBLISHED: "PUBLISHED" };
